export default function useIsQuickRegistration(user) {
  return user.email && user.email.indexOf('notarealaddress.demodern.de') > -1;
}
